// removed by extract-text-webpack-plugin
module.exports = {"authPage":"styles__authPage___2WUtT","inputCol":"styles__inputCol___3LJwt","submitRow":"styles__submitRow___1QcLf","errorMessageBox":"styles__errorMessageBox___P0zdB"};


//////////////////
// WEBPACK FOOTER
// ./src/app/authPage/styles.scss
// module id = 660
// module chunks = 0